"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.createTable(_globals.MetaTable.EXTENSIONS, (table)=>{
        table.string('id', 20).primary();
        table.string('base_id', 20).index();
        table.string('fk_user_id', 20);
        table.string('extension_id');
        table.string('title');
        table.text('kv_store');
        table.text('meta');
        table.float('order');
        table.timestamps(true, true);
    });
};
const down = async (knex)=>{
    await knex.schema.dropTable(_globals.MetaTable.EXTENSIONS);
};
